import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static values = { url: String }

  switchDirectDebitType(e) {
    preventDefaultAndStopPropagation(e);

    const url = e.target.dataset.directDebitTypesUrlValue;

    $("#direct_debit_form").attr('src', url )
    $(".direct-debit-types-container a.nav-link").removeClass('active');
    $(e.target).addClass('active');
  }
}
